<section id="login">
  <form (keydown)="EnterKeyTrigger($event)" [formGroup]="AuthenticationForm">
    <div class="container-fluid login-bg">
      <div class="row full-height-vh m-0  d-flex align-items-center justify-content-center">
        <div class="col-md-7 col-sm-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body fg-image">
                <div class="row m-0">


                  <div class="col-lg-6 d-none d-lg-block text-center py-3">
                    <img [src]="ProjectLogo" alt="" class="img-fluid mt-4" width="400"
                      height="230" />
                  </div>

                  <div class="col-lg-6 col-md-12 bg-white px-4 pt-3">
                    <h4 class="card-title mb-2">
                      <span class="app-label-icon pr-1"><i class="fa-solid fa-right-to-bracket"></i></span>
                      <span>{{ 'app.trn-login' | translate }}</span>
                    </h4>
                    <p class="card-text mb-2"> {{ 'app.trn-login-title-message' | translate }}
                    </p>

                    <div>
                      <mat-form-field>
                        <mat-label>
                          <span class="app-label-icon pr-1"><i class="fa-solid fa-user"></i></span>
                          <span>{{ 'app.trn-username' | translate }}</span>
                        </mat-label>

                        <input matInput type="text" formControlName="username">
                        <mat-error class="tc-warn"
                          *ngIf="(AuthenticationForm.get('username').invalid || AuthenticationForm.get('username').hasError('isInvalid')) && AuthenticationForm.get('username').touched">
                          <span>{{ 'app.trn-username-required' | translate }}</span>
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div>
                      <mat-form-field>
                        <mat-label>
                          <span class="app-label-icon pr-1"><i class="fa-solid fa-lock"></i></span>
                          <span>{{ 'app.trn-password' | translate }}</span>
                        </mat-label>
                        <input matInput [type]="HiddenPassword ? 'password' : 'text'" formControlName="password">
                        <mat-icon class="cursor-pointer" matSuffix (click)="HiddenPassword = !HiddenPassword">{{HiddenPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                        <mat-error class="tc-warn"
                          *ngIf="(AuthenticationForm.get('password').invalid || AuthenticationForm.get('password').hasError('isInvalid')) && AuthenticationForm.get('password').touched">
                          <span>{{ 'app.trn-password-required' | translate }}</span>
                        </mat-error>
                      </mat-form-field>
                    </div>

                      <div class="fg-actions d-flex justify-content-between mt-2">

                        <div class="login-btn">
                          <button (click)="onSignIn()" class="btn btn-primary">
                            <a class="text-decoration-none text-white">{{ 'app.trn-login' | translate }}</a>
                          </button>
                        </div>
  
  
                      </div>
         

                    <hr class="m-0 mt-2" />
                    <mat-progress-bar *ngIf='isLoading' mode="query"></mat-progress-bar>

                    <div class="d-flex justify-content-between mt-2 mb-2">

                      <div *ngIf='AllowRegistration' class="other-btn">
                        <button (click)="onRegistration()" class="btn btn-outline-primary">
                          <a class="text-decoration-none">{{ 'app.trn-register' | translate }}</a>
                        </button>
                      </div>

                      <div *ngIf='RescueLine_OLD_URL' class="other-btn pr-1">
                        <button (click)="OpenRescueLineURL()" class="btn btn-outline-primary">
                          <a class="text-decoration-none">{{ 'app.trn-go-to-previous-version' | translate }}</a>
                        </button>
                      </div>

                      <div *ngIf="AppShowThisSection" class="other-btn">
                        <button (click)="onForgotPassword()" class="btn btn-outline-primary">
                          <a class="text-decoration-none">{{ 'app.trn-recover-password' | translate }}</a>
                        </button>
                      </div>

                    </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </form>
</section>
